/* =========================================================
   EYESHELLS: Split engo-scripts.js -> engo-core.js (global)
   - Keeps header search/autocomplete, cart links, menus, popups
   - Keeps back-to-top / chat avoidance helper
   - Adds small global initializers (popup recommended slider)
   ========================================================= */

/*
  Legacy swatch click handler removed.
  (It set BOTH primary+secondary images to the same URL, which made hover swap look "broken".)
  Swatch behavior is now handled by assets/es-swatch-ES.js (capturing) + the theme's updated logic.
*/

/* Live search */
var engoAutoComplate = {
  initProductsRecently: function() {
    var self = this;
    if (!jQuery.cookie('brilliant_products_recently') || jQuery.cookie('brilliant_products_recently') == null) {      
      $(".engoj-recently-wrapper").append('<div class="no-products" style="flex-direction: column;"> <!--?xml version="1.0" encoding="iso-8859-1"?--> <!-- Generator: Adobe Illustrator 17.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --> <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewbox="0 0 455 455" style="enable-background:new 0 0 455 455;" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve"> <g> <path d="M360.967,130.599c-4.06-0.818-8.018,1.8-8.841,5.86c-0.823,4.06,1.801,8.018,5.86,8.841 c1.147,0.232,2.013,1.286,2.013,2.45v160c0,1.355-1.145,2.5-2.5,2.5H179.676c-4.142,0-7.5,3.357-7.5,7.5s3.358,7.5,7.5,7.5H357.5 c9.649,0,17.5-7.851,17.5-17.5v-160C375,139.46,369.099,132.247,360.967,130.599z"></path> <path d="M274.824,130.25H97.5c-9.649,0-17.5,7.851-17.5,17.5v160c0,8.063,5.48,15.046,13.326,16.982 c0.604,0.149,1.208,0.221,1.803,0.221c3.369,0,6.432-2.287,7.276-5.705c0.992-4.021-1.463-8.086-5.484-9.078 c-0.955-0.235-1.92-1.143-1.92-2.42v-160c0-1.355,1.145-2.5,2.5-2.5h177.324c4.142,0,7.5-3.357,7.5-7.5 S278.966,130.25,274.824,130.25z"></path> <path d="M235.363,170.798c-2.655-0.363-5.3-0.548-7.863-0.548c-31.706,0-57.5,25.794-57.5,57.5c0,2.563,0.185,5.209,0.548,7.863 c0.515,3.759,3.731,6.483,7.421,6.483c0.339,0,0.682-0.023,1.027-0.07c4.104-0.562,6.975-4.345,6.413-8.448 c-0.271-1.982-0.409-3.943-0.409-5.828c0-23.435,19.065-42.5,42.5-42.5c1.884,0,3.845,0.138,5.828,0.409 c4.108,0.564,7.886-2.309,8.448-6.413C242.338,175.143,239.467,171.359,235.363,170.798z"></path> <path d="M219.127,284.636c2.789,0.407,5.605,0.614,8.373,0.614c31.706,0,57.5-25.794,57.5-57.5c0-2.77-0.207-5.587-0.613-8.373 c-0.599-4.099-4.408-6.934-8.505-6.337c-4.099,0.599-6.936,4.406-6.337,8.505c0.303,2.071,0.456,4.158,0.456,6.205 c0,23.435-19.065,42.5-42.5,42.5c-2.044,0-4.132-0.153-6.205-0.456c-4.099-0.6-7.907,2.238-8.505,6.337 S215.028,284.037,219.127,284.636z"></path> <path d="M318.5,203.25c9.098,0,16.5-7.402,16.5-16.5c0-8.318-6.227-15.355-14.484-16.37c-2.293-0.277-4.585,0.509-6.218,2.142 l-10.027,10.027c-1.633,1.632-2.422,3.926-2.141,6.217C303.145,197.023,310.183,203.25,318.5,203.25z"></path> <path d="M117.5,114.75h30c4.142,0,7.5-3.357,7.5-7.5s-3.358-7.5-7.5-7.5h-30c-4.142,0-7.5,3.357-7.5,7.5 S113.358,114.75,117.5,114.75z"></path> <path d="M388.367,66.633C345.397,23.664,288.268,0,227.5,0S109.603,23.664,66.633,66.633C23.664,109.603,0,166.732,0,227.5 s23.664,117.897,66.633,160.867C109.603,431.336,166.732,455,227.5,455s117.897-23.664,160.867-66.633 C431.336,345.397,455,288.268,455,227.5S431.336,109.603,388.367,66.633z M15,227.5C15,110.327,110.327,15,227.5,15 c55.894,0,106.807,21.703,144.783,57.11L72.11,372.283C36.703,334.307,15,283.395,15,227.5z M227.5,440 c-55.894,0-106.807-21.703-144.783-57.11L382.89,82.717C418.297,120.693,440,171.606,440,227.5C440,344.673,344.673,440,227.5,440z "></path> </g> </svg> <div class="title_noprod"> <span> Sorry, there are no products. </span> </div> </div>');
    } else {
      $(".engoj-recently-wrapper > .no-products").remove();
      var arr = jQuery.cookie('brilliant_products_recently').split('|'); // split string to array
      for ( var i = 0; i < arr.length; i++){
        var handle = arr[i]; 
        self.ajaxProductsRecently(handle);
      }

      $('.js_prod_recent').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        infinite: false,
        vertical: true,
        verticalSwiping: true,
        focusOnSelect: true,
        prevArrow: '<button type="button" class="slick-brand-prev fa-solid fa-angle-left"></button>',
        nextArrow: '<button type="button" class="slick-brand-next fa fa-angle-down"></button>',

        responsive: [
          {
            breakpoint: 1200,
            settings: {
            }
          },
          {
            breakpoint: 768,
            settings: {
            }
          },

          {
            breakpoint: 574,
            settings: {
              slidesToShow: 1,
            }
          }
        ]
      });
    }
  },

  ajaxProductsRecently: function(handle) {
    var ajaxUrl = '/products/'+handle+'.js',
        result     = new Array();
    jQuery.ajax({
      type: 'GET',
      dataType: "json",
      url: ajaxUrl,
      beforeSend: function() {
        jQuery(".js_prod_recent").append('<div class="items d-flex align-items-md-center align-items-start engoj-recently-'+handle+'"><svg xml:space="preserve" style="enable-background:new 0 0 50 50;margin-top: -1px;" viewBox="0 0 24 30" height="20px" width="21px" y="0px" x="0px" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" id="Layer_1" version="1.1"><rect opacity="0.2" fill="#000" height="8" width="3" y="10" x="0"><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="0.2; 1; .2" attributeType="XML" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="10; 20; 10" attributeType="XML" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="10; 5; 10" attributeType="XML" attributeName="y"/></rect><rect opacity="0.2" fill="#000" height="8" width="3" y="10" x="8">      <animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="0.2; 1; .2" attributeType="XML" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="10; 20; 10" attributeType="XML" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="10; 5; 10" attributeType="XML" attributeName="y"/></rect><rect opacity="0.2" fill="#000" height="8" width="3" y="10" x="16"><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="0.2; 1; .2" attributeType="XML" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="10; 20; 10" attributeType="XML" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="10; 5; 10" attributeType="XML" attributeName="y"/></rect></svg></div>');
      },
      success: function(product) {
        var title            = product.title,
            price            = product.price,
            handle           = product.handle,
            image            = product.featured_image,
            template         = '<div class="img_left"> <a href="/products/'+ handle +'"> <img src="' + image + '" class="img-responsive" alt="'+title+'"> </a> </div> <div class="info_right position-absolute"> <a class="product-title" href="/products/'+ handle +'">'+title+'</a> <p class="price-product"><span class="price">'+ Shopify.formatMoney(price, window.money_format) +'</span></p> <div class="product-icon-action"> <div class="add-to-cart"> <a href="/products/'+ handle +'"><span>Buy now</span></a> </div> </div> </div>';       
            jQuery('.engoj-recently-'+handle).html(template);
      }
    });
  },

  ajaxProductItems : function( input_element, result_wrapper, result_element ){
    var ajaxUrl  = '/search',
        result     = new Array(),
        keyword   = input_element.val();

    jQuery.ajax({
        type: 'GET',
        data: {
            q: "*" + keyword + "*",
            type: "product",
            view: "json",
        },
        dataType: "json",      
        url: ajaxUrl,
        beforeSend: function() {
          result_wrapper.show();
          result_element.html('<p class="col-12"><svg xml:space="preserve" style="enable-background:new 0 0 50 50;margin-top: -1px;" viewBox="0 0 24 30" height="20px" width="21px" y="0px" x="0px" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" id="Layer_1" version="1.1"><rect opacity="0.2" fill="#000" height="8" width="3" y="10" x="0"><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="0.2; 1; .2" attributeType="XML" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="10; 20; 10" attributeType="XML" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="10; 5; 10" attributeType="XML" attributeName="y"/></rect><rect opacity="0.2" fill="#000" height="8" width="3" y="10" x="8">      <animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="0.2; 1; .2" attributeType="XML" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="10; 20; 10" attributeType="XML" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="10; 5; 10" attributeType="XML" attributeName="y"/></rect><rect opacity="0.2" fill="#000" height="8" width="3" y="10" x="16"><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="0.2; 1; .2" attributeType="XML" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="10; 20; 10" attributeType="XML" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="10; 5; 10" attributeType="XML" attributeName="y"/></rect></svg> Loading...</p>');
        },
        complete:function(){
        },
        success: function ( reponse ) {
          var htmlbox = '';
          //result_element.html('');
          if( reponse.length > 0 ){
            for (var i = 0; i < reponse.length; i++) {

              var item              = reponse[i],
                  title            = item.title,
                  price            = item.price,
                  handle           = item.handle,
                  image            = item.featured_image,
                  compare_price    = item.compare_at_price  ? '<s class="price-old">' + Shopify.formatMoney(item.compare_at_price, window.money_format) + '</s>' : "",
                  sold_out	       = item.available          ? "" : "<span class='item-sold-out'>Out of stock</span> ",
                  price            = item.available          ? item.price : item.out_stock_nofication,
                  hightlight     = title.replace(new RegExp('(' + keyword + ')', 'gi'), '<span class="hightlight">$1</span>'),
                  template         = '<div class="col-lg-4 col-sm-6 col-md-6"><ul class="prod_sidebar"><li class="product_info">'
                                      + '<a href="/products/'+ handle +'">'
                                      + '<img style="width: 100% "src="' + image + '" class="img-responsive"/>' 
                                      +'</a>'
                                      +'<h4 class="title-product"><a href="/products/'+ handle +'">' + hightlight +'</a></h4>'
                                      +'<span><p class="price-product mb-0"><span class="price">'+ Shopify.formatMoney(price, window.money_format) +'</span>'+ compare_price +'</p></span>'
                  					  + sold_out
                                      +'</li></ul></div>';
              htmlbox = htmlbox + template;
                 

            }
            result_element.html(htmlbox);
            
            if($('.js_productSearchResults .js_search_results li').length){
              $('.js_productSearchResults').show();
           
            }
          }else{
            result_element.html('<p class="col-12">No result found for your search.</p>');
             $('.js_productSearchResults').show();
          }
       }     
    });

  },
  
  ajaxSearch : function( options ){    
    var     ajax_timeout,
    		ajax_lost_focus,
            self        = this,
            search_input_id    = options.search_input.length   > 0   ? options.search_input    : '.js_engo_autocomplate',
            wrapper_id         = options.result_wrapper.length > 0   ? options.result_wrapper  : '.js_productSearchResults',
            result_id          = options.result_element.length > 0   ? options.result_element  : '.js_search_results';

    jQuery( document ).delegate( search_input_id ,'keyup',function( event ){
      if (jQuery(this).data('esSearchEnhanced')) { return; }
      var keyword           = jQuery(this).val(),
          search_element    = jQuery(this),
          result_wrapper    = jQuery( wrapper_id ),
          result_element    = result_wrapper.children( result_id );
        
      if( ajax_timeout ){ 
        clearTimeout(ajax_timeout);
      } 

      ajax_timeout = setTimeout(function() {
        if( keyword.length >= 2 ){
            self.ajaxProductItems( search_element ,result_wrapper, result_element );
        }else{
            result_element.html('<p class="col-12">You must enter at least 2 characters.</p>');
        } 
      },300);       
    }); 

  },
  
  init : function( options ){
    this.ajaxSearch( options );
  }
  
}

jQuery(document).ready(function($) {  
  engoAutoComplate.init({
    "search_input"      :   ".js_engo_autocomplate",
    "result_wrapper"   :   ".js_productSearchResults",
    "result_element"   :   ".js_search_results"
  });
      
  if (document.querySelector('.engoj-recently-wrapper')) { engoAutoComplate.initProductsRecently(); }
});




jQuery(document).ready(function($) {
  /* ES: tooltips disabled site-wide */
  /* $('[data-toggle=\"tooltip\"]').tooltip(); */
  /* ES UX: disable tooltip for quickview icons (all pages) */
  try {
    var $qv = $('.engoj_btn_quickview, .icon-quickview, .quickview-link');
    if ($qv.length && $qv.tooltip) { $qv.tooltip('dispose'); }
    $qv.removeAttr('data-toggle data-original-title title aria-describedby');
  } catch (e) {}
  $(document).on('mouseenter', '.engoj_btn_quickview, .icon-quickview, .quickview-link', function(){
    $(this).removeAttr('data-toggle data-original-title title aria-describedby');
  });
});





jQuery(document).ready(function($) {
  "use strict";

  var esDelayedPopupRegistry = window.__esDelayedPopupRegistry || (window.__esDelayedPopupRegistry = {});

  function esClearDelayedPopup(key){
    var state = esDelayedPopupRegistry[key];
    if (!state) return;
    try { if (state.timer) clearTimeout(state.timer); } catch (e) {}
    state.timer = null;
    if (state.onVisibilityChange) {
      try { document.removeEventListener('visibilitychange', state.onVisibilityChange); } catch (e) {}
    }
    if (state.onPageHide) {
      try { window.removeEventListener('pagehide', state.onPageHide); } catch (e) {}
    }
    delete esDelayedPopupRegistry[key];
  }

  function esScheduleDelayedPopup(key, delay, onFire){
    esClearDelayedPopup(key);
    var state = { timer: null, fired: false, onVisibilityChange: null, onPageHide: null };

    function fire(){
      if (state.fired) return;
      state.fired = true;
      esClearDelayedPopup(key);
      try { onFire(); } catch (e) {}
    }

    function arm(){
      if (state.fired || document.visibilityState === 'hidden') return;
      try { if (state.timer) clearTimeout(state.timer); } catch (e) {}
      state.timer = setTimeout(fire, delay);
    }

    state.onVisibilityChange = function(){
      if (document.visibilityState === 'hidden') {
        try { if (state.timer) clearTimeout(state.timer); } catch (e) {}
        state.timer = null;
      } else {
        arm();
      }
    };

    state.onPageHide = function(){
      esClearDelayedPopup(key);
    };

    esDelayedPopupRegistry[key] = state;
    document.addEventListener('visibilitychange', state.onVisibilityChange);
    window.addEventListener('pagehide', state.onPageHide);

    if (document.readyState === 'complete') {
      arm();
    } else {
      $(window).off('load.' + key).on('load.' + key, arm);
    }
  }

  function promo(){
    $('.close_promo_topbar').off('click.esPromoTopbar').on('click.esPromoTopbar', function(){
      $('.promo_topbar').addClass('active');
    });
  }

  function search(){
    $('.js-search-destop').off('click.esDesktopSearchOpen').on('click.esDesktopSearchOpen', function() {
      $('.js-box-search').addClass('active');
      $('.bg_search_box').addClass('active');
      $('body').addClass('activedestop');
    });
    $('.js-drawer-close').off('click.esDesktopSearchClose').on('click.esDesktopSearchClose', function() {
      $('.js-box-search').removeClass('active');
      $('.bg_search_box').removeClass('active');
      $('body').removeClass('activedestop');
    });
    $('.bg_search_box').off('click.esDesktopSearchBackdrop').on('click.esDesktopSearchBackdrop', function() {
      $('.js-box-search').removeClass('active');
      $('.bg_search_box').removeClass('active');
      $('body').removeClass('activedestop');
    });
  }

  function bindCartLinks(){
    $(document)
      .off('click.eyeshellsCartNav')
      .on('click.eyeshellsCartNav', '.js-cart-link', function(){
        try { if (window.EyeshellsCartNav && typeof window.EyeshellsCartNav.goToCart === 'function') { window.EyeshellsCartNav.goToCart(); return; } } catch(e) {}
      });
  }

/* Eyeshells: allow ESC to close open popups (quickview / filters / add-to-cart) */
$(document)
  .off('keyup.eyeshellsEscClose')
  .on('keyup.eyeshellsEscClose', function(e) {
    var key = e.key || e.keyCode;
    if (key !== 'Escape' && key !== 'Esc' && key !== 27) return;

    // 1) Quickview modal
    if ($('.quickview-product').hasClass('active') || $('.tshopify-popup').hasClass('active')) {
      try {
        if (typeof window.hidePopup === 'function') {
          window.hidePopup('.tshopify-popup');
          window.hidePopup('.quickview-product');
        } else {
          $('.quickview-product').addClass('es-qv-closing');
          $('.tshopify-popup, .quickview-product').removeClass('active');
          setTimeout(function(){ $('.quickview-product').removeClass('es-qv-closing'); }, 220);
        }
      } catch (_esQvEscClose) {
        $('.quickview-product').addClass('es-qv-closing');
        $('.tshopify-popup, .quickview-product').removeClass('active');
        setTimeout(function(){ $('.quickview-product').removeClass('es-qv-closing'); }, 220);
      }
      setTimeout(function(){ $('.loading').removeClass('loaded-content'); }, 300);
      return;
    }

    // 2) Ajax add-to-cart popup
    if ($('.engo-popup.active').length) {
      $('.engo-popup').removeClass('active');
      return;
    }

    // 3) Filter drawer
    if ($('.filter-to-left').hasClass('active')) {
      $('.filter-to-left').removeClass('active');
      $('.overlay-filter').removeClass('active');
      return;
    }
  });



/* Eyeshells: robust close for Ajax add-to-cart popup (X / overlay) even if other scripts stop bubbling */
(function() {
  if (window.__eyeshellsPopupCloseCaptureBound) return;
  window.__eyeshellsPopupCloseCaptureBound = true;

  function removeActive(selector) {
    var nodes = document.querySelectorAll(selector);
    for (var i = 0; i < nodes.length; i++) nodes[i].classList.remove('active');
  }

  document.addEventListener('click', function(ev) {
    var t = ev.target;
    if (!t || !t.closest) return;

    // Ajax add-to-cart success popup
    if (t.closest('.product-popup .close-window') || t.closest('.product-popup .overlay-addcart') || t.closest('.product-popup .continue-shopping')) {
      removeActive('.product-popup');
      return;
    }

    // Error popup
    if (t.closest('.error-popup .close-window') || t.closest('.error-popup .overlay-addcart')) {
      removeActive('.error-popup');
      return;
    }
  }, true); // capture: run before bubble handlers

})();

/* Header badge cleanup (mobile)
   - Show 0 on empty cart counter
   - Cap large numbers to 9+
   - Keep badge stable when updated by Ajax
*/
(function(){
  function formatCount(n){
    return (n > 9) ? '9+' : String(n);
  }

  function updateCartBadge(){
    var els = document.querySelectorAll('.enj-cartcount');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var n = parseInt((el.textContent || '').trim(), 10) || 0;
      el.classList.remove('es-badge-hidden');
      el.classList.toggle('is-zero-count', n === 0);
      el.textContent = formatCount(n);
    }
  }

  function updateAll(){
    updateCartBadge();
    // Wishlist counter is handled in swym-custom.liquid (show-badge toggle + 0 hide)
  }

  function observe(){
    if (!window.MutationObserver) return;
    var root = document.querySelector('.menu_moblie') || document.querySelector('#header') || document.body;
    if (!root) return;
    var mo = new MutationObserver(function(){
      // Debounce via rAF to avoid overwork during rapid DOM writes
      if (observe._raf) return;
      observe._raf = requestAnimationFrame(function(){
        observe._raf = null;
        updateAll();
      });
    });
    mo.observe(root, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){
      updateAll();
      observe();
    });
  } else {
    updateAll();
    observe();
  }

  // Also listen for common cart update events if present
  document.addEventListener('cart:updated', updateAll);
})();
  function jscalllogindestop(){
    $('.js-call-popup-login').off('click.esLoginPopupOpen').on('click.esLoginPopupOpen', function() {
      $('.js-poup-login-destop').addClass('active');
      $('.js-bg-login-popup').addClass('active');
    });
    $('.js-eveland-close-login').off('click.esLoginPopupClose').on('click.esLoginPopupClose', function() {
      $('.js-poup-login-destop').removeClass('active');
      $('.js-bg-login-popup').removeClass('active');
    });
    $('.js-bg-login-popup').off('click.esLoginPopupBackdrop').on('click.esLoginPopupBackdrop', function() {
      $('.js-poup-login-destop').removeClass('active');
      $('.js-bg-login-popup').removeClass('active');
    });
  }

  function jsBackLogin(){
    $('.jsCreate_account').off('click.esLoginFormCreate').on('click.esLoginFormCreate', function() {
      $('.form_register').show();
      $('.formlogin').hide();
    });
    $('.tab_navar_right').off('click.esLoginFormTabs').on('click.esLoginFormTabs', function() {
      $('.formlogin').show();
      $('.form_register').hide();
    });

    $('.jsBack_login').off('click.esLoginFormBack').on('click.esLoginFormBack', function() {
      $('.formlogin').show();
      $('.form_register').hide();
    });
    $('.jsacount_destop').off('click.esLoginFormDesktop').on('click.esLoginFormDesktop', function() {
      $('.formlogin').show();
      $('.form_register').hide();
    });
  }



  function jslogindestop(){
    $('.jsCreate_account').off('click.esDesktopLoginCreate').on('click.esDesktopLoginCreate', function() {
      $('.form_register-destop').show();
      $('.formlogin-destop').hide();
    });
    $('.js-call-popup-login').off('click.esDesktopLoginOpen').on('click.esDesktopLoginOpen', function() {
      $('.formlogin-destop').show();
      $('.form_register-destop').hide();
    });

    $('.jsBack_login').off('click.esDesktopLoginBack').on('click.esDesktopLoginBack', function() {
      $('.formlogin-destop').show();
      $('.form_register-destop').hide();
    });
    $('.jsacount_destop').off('click.esDesktopLoginAccount').on('click.esDesktopLoginAccount', function() {
      $('.formlogin-destop').show();
      $('.form_register-destop').hide();
    });
  }




  function esRafThrottle(fn) {
    var ticking = false;
    return function() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function(){
        ticking = false;
        fn();
      });
    };
  }

  function mobilescroll() {
    $(window).off('scroll.esMobileMenuState resize.esMobileMenuState');
    $('.es-mobile-header-sticky-spacer').remove();
    $('.menu_moblie').removeClass('menu_mobilescroll').removeAttr('data-es-sticky-natural-height');
  }

  function menumobile() {
    function setMobileMenuState(open) {
      var isOpen = !!open;
      var $trigger = $('.js-mobile-menu-toggle');
      $trigger.attr('aria-expanded', isOpen ? 'true' : 'false');
      $trigger.toggleClass('active', isOpen);
      $('.menuleft').toggleClass('active', isOpen);
      $('.box_contentmenu').toggleClass('active', isOpen);
      $('.box_contentmenu_background').toggleClass('active', isOpen);
      $('body').toggleClass('activemenu_mobile', isOpen);
    }

    $('.js-mobile-menu-toggle')
      .off('click.esMobileMenuToggle')
      .on('click.esMobileMenuToggle', function(e) {
        e.preventDefault();
        e.stopPropagation();
        setMobileMenuState(!$('.box_contentmenu').hasClass('active'));
      });

    $('.logo_menumoblie a, .logo_menumoblie .logourl')
      .off('click.esMobileMenuLogoNav')
      .on('click.esMobileMenuLogoNav', function(e) {
        e.stopPropagation();
        setMobileMenuState(false);
      });

    $('.box_contentmenu_background')
      .off('click.esMobileMenuBackdrop')
      .on('click.esMobileMenuBackdrop', function() {
        setMobileMenuState(false);
      });

    $('.js-eveland-close')
      .off('click.esMobileMenuClose')
      .on('click.esMobileMenuClose', function() {
        setMobileMenuState(false);
      });

    $('.box_contentmenu a')
      .off('click.esMobileMenuLinkNav')
      .on('click.esMobileMenuLinkNav', function() {
        setMobileMenuState(false);
      });

    $(window)
      .off('pageshow.esMobileMenuState pagehide.esMobileMenuState beforeunload.esMobileMenuState')
      .on('pageshow.esMobileMenuState pagehide.esMobileMenuState beforeunload.esMobileMenuState', function() {
        setMobileMenuState(false);
      });

    setMobileMenuState(false);
  }

  function popup(){
    $('.jsclosepoup').off('click.esNewsletterDismiss').on('click.esNewsletterDismiss', function() {
      $('.jsengo_popup').addClass('d-none');

    });
  }
  function cookiepopup(){
    if (!jQuery.cookie('brilliant_pop_newletter') || jQuery.cookie('brilliant_pop_newletter') == null) {
      esScheduleDelayedPopup('esNewsletterPopup', 300 * 1000, function(){
        if (document.visibilityState === 'hidden') return;
        if (!$('.jsengo_popup').length) return;
        $('.jsengo_popup').show();
      });
      jQuery('.jsclosepoup').off('click.esNewsletterPopup').on('click.esNewsletterPopup', function(e) {
        e.preventDefault();
        esClearDelayedPopup('esNewsletterPopup');
        jQuery('.jsengo_popup').hide();
        jQuery.cookie('brilliant_pop_newletter', '1', {expires: 1, path:'/', domain: '' });
      });
    } else {
      esClearDelayedPopup('esNewsletterPopup');
      $(window).off('load.esNewsletterPopup');
      $('.jsengo_popup').remove();
    }
  }


  // Scroll to TOP
  function totop(){
    var back_to_top = $('#back-to-top');
    if (back_to_top.length) {
      var scrollTrigger = 100; // px
      var backToTop = esRafThrottle(function() {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
        if (scrollTop > scrollTrigger) {
          back_to_top.addClass('show');
        } else {
          back_to_top.removeClass('show');
        }
      });
      $(window).off('scroll.esBackToTop').on('scroll.esBackToTop', backToTop);
      back_to_top.off('click.esBackToTop').on('click.esBackToTop', function(e) {
        e.preventDefault();
        $('html,body').animate({
          scrollTop: 0
        }, 700);
      });
      backToTop();
    }
  }


  function popup2(){
    $('.jsclose_cookie').off('click.esCookieDismiss').on('click.esCookieDismiss', function() {
      $('.jscookie_popup').addClass('d-none');

    });
  }

  function jsmenu_fullwidth(){
    var $header = $('.js_height_hd');
    var $fullWidth = $('.js-full-width');
    if (!$header.length || !$fullWidth.length) return;

    var update = esRafThrottle(function() {
      var top = $header.offset();
      var height = $header.outerHeight() || 0;
      if (!top) return;
      $fullWidth.css({'position':'fixed','left':'0','right':'0','width':'100%'});
      if ((window.pageYOffset || document.documentElement.scrollTop || 0) >= height){
        $fullWidth.css({'top' : height - 15 });
      }
      else{
        $fullWidth.css({'top' : top.top + height - 15 });
      }
    });

    $(window).off('scroll.esFullWidthMenu resize.esFullWidthMenu').on('scroll.esFullWidthMenu resize.esFullWidthMenu', update);
    update();
  }
  
  function cookiepopup2() {
    if (!jQuery.cookie('cookie_popup') || jQuery.cookie('cookie_popup') == null) {
      esScheduleDelayedPopup('esCookiePopup', 300 * 1000, function(){
        if (document.visibilityState === 'hidden') return;
        if (!$('.jscookie_popup').length) return;
        $('.jscookie_popup').show();
      });
      jQuery('.jsclose_cookie').off('click.esCookiePopup').on('click.esCookiePopup', function(e) {
        e.preventDefault();
        esClearDelayedPopup('esCookiePopup');
        jQuery('.jscookie_popup').hide();
        jQuery.cookie('cookie_popup', '1', {expires: 1, path:'/', domain: '' });
      });
    } else {
      esClearDelayedPopup('esCookiePopup');
      $(window).off('load.esCookiePopup');
      $('.jscookie_popup').remove();
    }
  }

  
  jsmenu_fullwidth();
  totop();
        // Back-to-top placement helper is defined later and attached to window.
        // Guard to avoid breaking all JS if it's not available for any reason.
        if (window.positionBackToTopNearChat) {
          window.positionBackToTopNearChat();
        }
  jslogindestop();
  jscalllogindestop();
  menumobile();
  jsBackLogin();
  mobilescroll();
  bindCartLinks();
  search();
  promo();

});

      
	      // (Removed) Ajax add-to-cart popup no longer requires a terms checkbox.

      ///////ZOOM IMAGE

      


(function($){
  $(function(){
    "use strict";
    // Popup recommended products slider (appears in ajax add-to-cart popup).
    function productnewh5(){
      var $el = $('.slick_product_new-h5');
      if (!$el.length) return;
      if ($el.hasClass('slick-initialized')) return;
      if (!$el.slick) return;

      $el.slick({
        arrows: true,
        infinite: false,
        dots: false,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 3,
        autoplay: true,
        autoplaySpeed: 2000,
        prevArrow:'<button type="button" class="prev-slide"><i class="fa-solid fa-angle-left"></i></button>',
        nextArrow:'<button type="button" class="next-slide"><i class="fa-solid fa-angle-right"></i></button>',
        responsive: [
          { breakpoint: 1200, settings: { slidesToShow: 3, arrows: true, infinite: false, dots: false } },
          { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 2 } },
          { breakpoint: 600,  settings: { slidesToShow: 2, arrows: true, infinite: false, dots: false } }
        ]
      });
    }

    productnewh5();
  });
})(window.jQuery);


// Back-to-top positioning near Shopify Inbox
// =========================================
(function () {
  function positionBackToTopNearChat() {
    var fab = document.getElementById('back-to-top');
    if (!fab) return;

    if (typeof window.__esBttCleanup === 'function') {
      try { window.__esBttCleanup(); } catch (e) {}
      window.__esBttCleanup = null;
    }

    fab.setAttribute('data-es-btt-init', '1');

    function clamp(n, min, max) {
      return Math.max(min, Math.min(max, n));
    }

    function isVisible(el) {
      if (!el) return false;
      var cs = window.getComputedStyle ? window.getComputedStyle(el) : null;
      if (cs && (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity || '1') === 0)) return false;
      var r = el.getBoundingClientRect ? el.getBoundingClientRect() : null;
      if (!r) return false;
      if (r.width < 2 || r.height < 2) return false;
      return true;
    }

    function rectLooksValid(r) {
      if (!r) return false;
      return r.width > 0 && r.height > 0 && r.bottom > 0 && r.right > 0 && r.top < window.innerHeight && r.left < window.innerWidth;
    }

    function looksLikeLauncherRect(r) {
      if (!r) return false;
      if (r.width < 32 || r.height < 32) return false;
      if (r.width > 260 || r.height > 260) return false;
      if (r.right < window.innerWidth - 320) return false;
      if (r.bottom < window.innerHeight - 320) return false;
      if (r.bottom <= 0 || r.right <= 0) return false;
      if (r.top >= window.innerHeight || r.left >= window.innerWidth) return false;
      return true;
    }

    function findShopifyInboxLauncher() {
      try {
        var inboxHost = document.querySelector('inbox-online-store-chat, #ShopifyChat, #shopify-chat inbox-online-store-chat');
        if (inboxHost && isVisible(inboxHost)) return inboxHost;
      } catch (e) {}

      var candidates = [];

      function pushAll(nodeList) {
        try {
          Array.prototype.forEach.call(nodeList, function (el) {
            if (el) candidates.push(el);
          });
        } catch (e) {}
      }

      var selectors = [
        '#shopify-chat',
        '#ShopifyChat',
        '#ShopifyInbox',
        '#ShopifyInboxLauncher',
        '.shopify-chat',
        '.ShopifyInbox__launcher',
        '.ShopifyInboxLauncher',
        '.shopify-inbox__launcher',
        '[data-shopify-chat]',
        '[data-shopify-inbox]',
        '[data-inbox-launcher]',
        'button[aria-label*="chat" i]',
        'button[title*="chat" i]',
        'a[aria-label*="chat" i]',
        'a[title*="chat" i]'
      ];

      selectors.forEach(function (sel) {
        try {
          pushAll(document.querySelectorAll(sel));
        } catch (e) {}
      });

      var iframes = Array.prototype.slice.call(document.querySelectorAll('iframe'));
      iframes.forEach(function (f) {
        try {
          var src = (f.getAttribute('src') || '').toLowerCase();
          var title = (f.getAttribute('title') || '').toLowerCase();
          var id = (f.id || '').toLowerCase();
          var cls = (f.className || '').toString().toLowerCase();

          var looksLikeInbox = (
            (src.includes('shopify') && (src.includes('inbox') || src.includes('chat') || src.includes('messaging'))) ||
            title.includes('inbox') ||
            title.includes('chat') ||
            id.includes('inbox') ||
            id.includes('chat') ||
            cls.includes('inbox') ||
            cls.includes('chat')
          );

          if (looksLikeInbox) candidates.push(f);
        } catch (e) {}
      });

      var likely = Array.prototype.slice.call(document.querySelectorAll('button, a, div'));
      for (var i = 0; i < likely.length; i++) {
        var el = likely[i];
        try {
          var cn = (el.className || '').toString().toLowerCase();
          var id2 = (el.id || '').toLowerCase();
          var aria = (el.getAttribute('aria-label') || '').toLowerCase();
          if (!(cn.includes('chat') || cn.includes('inbox') || id2.includes('chat') || id2.includes('inbox') || aria.includes('chat') || aria.includes('inbox'))) {
            continue;
          }
          var st = window.getComputedStyle(el);
          if (st.position !== 'fixed') continue;
          var r = el.getBoundingClientRect();
          if (!rectLooksValid(r)) continue;
          candidates.push(el);
        } catch (e) {}
      }

      var seen = new Set();
      var uniq = [];
      candidates.forEach(function (el) {
        if (!el) return;
        if (seen.has(el)) return;
        seen.add(el);
        uniq.push(el);
      });

      var best = null;
      var bestScore = 1e18;

      function scoreRect(r) {
        var dx = Math.max(0, window.innerWidth - r.right);
        var dy = Math.max(0, window.innerHeight - r.bottom);
        var corner = dx * dx + dy * dy;
        var area = r.width * r.height;
        var penalty = 0;
        if (r.width > 260 || r.height > 260) penalty += 8e8;
        if (r.width < 36 || r.height < 36) penalty += 5e8;
        if (r.right < window.innerWidth - 320) penalty += 8e8;
        if (r.bottom < window.innerHeight - 320) penalty += 8e8;
        return corner + area + penalty;
      }

      for (var j = 0; j < uniq.length; j++) {
        var el2 = uniq[j];
        try {
          if (!isVisible(el2)) continue;
          var r2 = el2.getBoundingClientRect();
          if (!rectLooksValid(r2)) continue;
          var s = scoreRect(r2);
          if (s < bestScore) {
            bestScore = s;
            best = el2;
          }
        } catch (e) {}
      }

      return best;
    }

    var scheduled = false;
    var observedEl = null;
    var ro = null;
    var mo = null;
    var retryTimers = [];
    var hidden = document.visibilityState === 'hidden';

    function clearRetryTimers() {
      for (var i = 0; i < retryTimers.length; i++) {
        try { clearTimeout(retryTimers[i]); } catch (e) {}
      }
      retryTimers.length = 0;
    }

    function scheduleRetryBackoff() {
      clearRetryTimers();
      if (hidden) return;
      [120, 260, 480, 820, 1300, 1900, 2600].forEach(function (ms) {
        retryTimers.push(setTimeout(function () {
          scheduleUpdate();
        }, ms));
      });
    }

    function scheduleUpdate() {
      if (scheduled || hidden) return;
      scheduled = true;
      (window.requestAnimationFrame || function(cb){ return setTimeout(cb, 16); })(function () {
        scheduled = false;
        updatePosition();
      });
    }

    function ensureResizeObserver(target) {
      if (!window.ResizeObserver) return;
      if (!target) return;
      if (observedEl === target) return;
      observedEl = target;
      if (ro) {
        try { ro.disconnect(); } catch (e) {}
      }
      ro = new ResizeObserver(scheduleUpdate);
      try { ro.observe(target); } catch (e) {}
    }

    function updatePosition() {
      var isMobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
      var defaultRight = isMobile ? 16 : 18;
      var defaultBottom = isMobile ? 120 : 128;
      var gapY = isMobile ? 10 : 12;
      var right = defaultRight;
      var bottom = defaultBottom;
      var anchoredToChat = false;

      var chatEl = findShopifyInboxLauncher();
      if (chatEl) {
        var r = chatEl.getBoundingClientRect();
        if (looksLikeLauncherRect(r)) {
          var chatRightDistance = Math.round(window.innerWidth - r.right);
          right = clamp(chatRightDistance, defaultRight, isMobile ? 72 : 88);
          var chatTopFromBottom = Math.round(window.innerHeight - r.top);
          bottom = clamp(chatTopFromBottom + gapY, isMobile ? 72 : 84, isMobile ? 240 : 260);
          anchoredToChat = true;
          ensureResizeObserver(chatEl);
        }
      }

      if (anchoredToChat) {
        fab.style.right = right + 'px';
        fab.style.bottom = bottom + 'px';
      } else {
        fab.style.right = 'calc(' + right + 'px + env(safe-area-inset-right))';
        fab.style.bottom = 'calc(' + bottom + 'px + env(safe-area-inset-bottom))';
      }
    }

    function onWindowChange() {
      scheduleUpdate();
    }

    function nodeLooksChatRelated(node) {
      try {
        if (!node || node.nodeType !== 1) return false;
        var tag = (node.tagName || '').toUpperCase();
        if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'LINK') return false;
        if (tag === 'IFRAME') return true;

        var hay = [
          node.id || '',
          node.className || '',
          node.getAttribute && node.getAttribute('aria-label') || '',
          node.getAttribute && node.getAttribute('title') || '',
          node.getAttribute && node.getAttribute('data-shopify-chat') || '',
          node.getAttribute && node.getAttribute('data-shopify-inbox') || '',
          node.getAttribute && node.getAttribute('data-inbox-launcher') || ''
        ].join(' ').toLowerCase();

        if (/chat|inbox|messag/.test(hay)) return true;

        return !!(node.querySelector && node.querySelector(
          'iframe, #shopify-chat, #ShopifyChat, #ShopifyInbox, #ShopifyInboxLauncher, .shopify-chat, .ShopifyInbox__launcher, .ShopifyInboxLauncher, .shopify-inbox__launcher, [data-shopify-chat], [data-shopify-inbox], [data-inbox-launcher], button[aria-label*="chat" i], a[aria-label*="chat" i], button[title*="chat" i], a[title*="chat" i]'
        ));
      } catch (e) {
        return false;
      }
    }

    function onVisibilityChange() {
      hidden = document.visibilityState === 'hidden';
      if (hidden) {
        clearRetryTimers();
      } else {
        scheduleUpdate();
        scheduleRetryBackoff();
      }
    }

    function cleanup() {
      clearRetryTimers();
      try { if (ro) ro.disconnect(); } catch (e) {}
      try { if (mo) mo.disconnect(); } catch (e) {}
      ro = null;
      mo = null;
      window.removeEventListener('resize', onWindowChange);
      window.removeEventListener('orientationchange', onWindowChange);
      window.removeEventListener('scroll', onWindowChange);
      document.removeEventListener('visibilitychange', onVisibilityChange);
      try { delete fab.__esBttScheduleUpdate; } catch (e) { fab.__esBttScheduleUpdate = null; }
      try { fab.removeAttribute('data-es-btt-init'); } catch (e) {}
    }

    scheduleUpdate();
    scheduleRetryBackoff();

    window.addEventListener('resize', onWindowChange, { passive: true });
    window.addEventListener('orientationchange', onWindowChange, { passive: true });
    window.addEventListener('scroll', onWindowChange, { passive: true });
    document.addEventListener('visibilitychange', onVisibilityChange);

    if (window.MutationObserver) {
      var moRoot = document.body || document.documentElement;
      mo = new MutationObserver(function (mutations) {
        if (hidden) return;
        for (var i = 0; i < mutations.length; i++) {
          var added = mutations[i].addedNodes;
          if (!added || !added.length) continue;
          for (var j = 0; j < added.length; j++) {
            if (nodeLooksChatRelated(added[j])) {
              scheduleUpdate();
              scheduleRetryBackoff();
              return;
            }
          }
        }
      });
      mo.observe(moRoot, { childList: true, subtree: true });
    }

    fab.__esBttScheduleUpdate = scheduleUpdate;
    window.__esBttCleanup = cleanup;
    window.addEventListener('pagehide', cleanup, { once: true });
  }
	  // Expose helper globally (so other scripts can call it without ReferenceError)
	  window.positionBackToTopNearChat = positionBackToTopNearChat;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', positionBackToTopNearChat);
  } else {
    positionBackToTopNearChat();
  }
})();
